@if(specialTemplates$ |async; as st) {
  @for (row of st; track $index) {
    <div class="row"><textarea  [(ngModel)]="st[$index]" ></textarea><button (click)="clickDel(st,$index)"><mat-icon>delete</mat-icon></button></div>
  }
  <div class="row">
  <button (click)="clickAdd(st)"><mat-icon>add-plus</mat-icon></button>
  <button mat-raised-button (click)="clickSave(st)">Speichern</button>
  </div>
}
